export default "__VITE_ASSET__59b8ba1d__"